import { AppFullscreen, Notify, Loading, Dialog } from "quasar";

Notify.setDefaults({
  position: "top",
  type: "info",
});

export const config = {
  plugins: {
    AppFullscreen,
    Notify,
    Loading,
    Dialog,
  }, // import Quasar plugins and add here
  config: {
    // extras: ["material-icons"],
    // brand: {
    //   primary: "#032f2b",
    //   secondary: "#03746d",
    //   accent: "#9c27b0",
    //   // dark: "#1d1d1d",
    //   // "dark-page": "#121212",
    //   positive: "#4caf50",
    //   negative: "#f44336",
    //   info: "#03a9f4",
    //   warning: "#ff9800",
    // },
  },
};

export const notifyError = (error: Error, tag: string = "LOG") => {
  console.error(`[Error][${tag}]:`, error);
  Notify.create({
    type: "negative",
    message: `[Error][${tag}]: ${error.message}`,
  });
};
export const confirmDialog = (options: {
  title?: string;
  message?: string;
  showCancel?: boolean;
}) => {
  const { title = "提示", message = "message", showCancel = true } = options;
  return new Promise((resolve, reject) => {
    Dialog.create({
      title: title,
      message: message,
      cancel: showCancel ? "取消" : false,
      ok: "确定",
      persistent: true,
    })
      .onOk(() => {
        // console.log('>>>> OK')
        resolve(true);
      })
      .onOk(() => {
        // console.log('>>>> second OK catcher')
        resolve(true);
      })
      .onCancel(() => {
        // console.log('>>>> Cancel')
        reject(false);
      })
      .onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
        reject(false);
      });
  });
};
